import React, { useEffect, useState } from "react";
import allenLogo from "../../../images/allenLogo.png";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Box,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import { decryptData } from "../../../crypto";
import { useLanguages } from "../../../context/LanguagesContext";
import { useProfile } from "../../../context/ProfileContext";
import user from "../../../images/user.png";
import clientlogo from "../../../images/clientlogo/ClientLogo.png";

function Header({ handleDrawerToggle, handleOpenInstructions }) {
const storedLogo = sessionStorage.getItem("client_logo");

const clientLogo =
  !storedLogo || storedLogo === "null" ? clientlogo : storedLogo;  const examName = decryptData(sessionStorage.getItem("exam_name"));

  const { languages, handleChange, selectedLanguage } = useLanguages();
  const { profile } = useProfile();

  return (
    <>

      <Typography
        fontWeight="bold"
        sx={{
          fontSize: { xs: "0.75rem", sm: "0.85rem" },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#ffffff",
          backgroundColor: "#000000",
          textAlign: "start",
          py: 0.5,
          px: 2,
          m: 0,
          lineHeight: 1.2,
          display: "block",
        }}
      >
        {examName}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: "6px 10px", sm: "8px 16px" },
          borderBottom: "1px solid #e0e0e0",
          background: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
          gap: { xs: 1, sm: 1.5 },
          minHeight: { xs: 48, sm: 56 },
        }}
      >
        {/* ── Left: Logo + Exam Name ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flex: 1,
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          {clientLogo && (
            <Box
              component="img"
              src={clientLogo}
              alt="logo"
              sx={{
                width: "auto",
                height: { xs: 34, sm: 44, md: 54 },
                objectFit: "contain",
                flexShrink: 0,
              }}
            />
          )}
        </Box>

        {/* ── Right: Language + Instruction + User + Hamburger ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.5, sm: 1.5 },
            flexShrink: 0,
          }}
        >
          {/* Language Selector — visible on ALL screen sizes */}
          <FormControl size="small">
            <Select
              value={selectedLanguage}
              onChange={handleChange}
              sx={{
                minWidth: { xs: 90, sm: 120 },
                height: { xs: 30, sm: 35 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              }}
            >
              {languages?.map((lang) => (
                <MenuItem key={lang.value} value={lang.value}>
                  {lang.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Instruction — icon only on mobile, icon + label on desktop */}
          <Tooltip title="Instructions">
            <Box
              onClick={handleOpenInstructions}
              sx={{
                display: { xs: "none", sm: "flex" },
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                "&:hover": { opacity: 0.7 },
              }}
            >
              <InfoOutlinedIcon
                sx={{ fontSize: { xs: 20, sm: 20 }, color: "#555" }}
              />
              <Typography
                sx={{
                  fontSize: "0.7rem",
                  color: "#555",
                  lineHeight: 1,
                }}
              >
                Instruction
              </Typography>
            </Box>
          </Tooltip>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img src={user} alt="user" height={28} />
            <Typography fontWeight="bold" sx={{ fontSize: "0.9rem", whiteSpace: "nowrap" }}>
              {profile?.full_name}
            </Typography>
          </Box>

          {/* Hamburger — mobile/tablet only */}
          <IconButton
            onClick={handleDrawerToggle}
            sx={{ display: { xs: "flex", md: "none" }, p: 0.5 }}
            aria-label="open question navigator"
          >
            <MenuIcon sx={{ fontSize: 26, color: "#444" }} />
          </IconButton>
        </Box>

      </Box>
    </>
  );
}

export default Header;
